export const CommissionsTabs = {
	SourceFiles: {
		name: "source-files",
		displayName: "Source Files",
	},
	ImportSourceData: {
		name: "import-source-data",
		displayName: "Import Source Data",
	},
	DataCleanse: {
		name: "data-cleanse",
		displayName: "Data Cleanse",
	},
	Calculations: {
		name: "calculations",
		displayName: "Calculations",
	},
	Adjustments: {
		name: "adjustments",
		displayName: "Adjustments",
	},
	CommissionPayments: {
		name: "commission-payments",
		displayName: "Commission Payments",
	},
	CommissionReporting: {
		name: "commission-reporting",
		displayName: "Commission Reporting",
	},
};
